import React, { useState } from 'react';
import styles from '../styles/panelList.module.css';

interface PanelItem {
  title: string;
  subtext: string;
  image_url: string;
  link_type: 'external' | 'document' | 'route';
  link_value: string;
}

interface PanelListWithImagesProps {
  title: string;
  subtext: string;
  items: PanelItem[];
  isExpanded?: boolean;
}

const PanelListWithImages: React.FC<PanelListWithImagesProps> = ({
  title,
  subtext,
  items,
  isExpanded = false
}) => {
  const [expanded, setExpanded] = useState(isExpanded);

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  const handleItemClick = (item: PanelItem) => {
    if (item.link_type === 'external' || item.link_type === 'document') {
      window.open(item.link_value, '_blank');
    } else if (item.link_type === 'route') {
      window.location.href = item.link_value;
    }
  };

  return (
    <div className={styles.panel}>
      <div className={styles.panelHeader} onClick={toggleExpanded}>
        <div className={styles.panelTitleSection}>
          <h3 className={styles.panelTitle}>{title}</h3>
          {subtext && <p className={styles.panelSubtext}>{subtext}</p>}
        </div>
        <button 
          className={`${styles.expandButton} ${expanded ? styles.expanded : ''}`}
          aria-label={expanded ? 'Collapse' : 'Expand'}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </button>
      </div>
      
      {expanded && (
        <div className={styles.panelContent}>
          <div className={styles.imageListGrid}>
            {items.map((item, index) => (
              <div 
                key={index} 
                className={styles.imageListItem}
                onClick={() => handleItemClick(item)}
              >
                <div className={styles.imageContainer}>
                  {item.image_url ? (
                    <img 
                      src={item.image_url} 
                      alt={item.title}
                      className={styles.itemImage}
                      loading="lazy"
                    />
                  ) : (
                    <div className={styles.placeholderImage}>
                      No Image
                    </div>
                  )}
                </div>
                <div className={styles.itemContent}>
                  <h4 className={styles.itemTitle}>{item.title}</h4>
                  <p className={styles.itemSubtext}>{item.subtext}</p>
                  <div className={styles.itemLink}>
                    {item.link_type === 'document' ? 'View Document' : 'Learn More'}
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                      <polyline points="15 3 21 3 21 9" />
                      <line x1="10" y1="14" x2="21" y2="3" />
                    </svg>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default PanelListWithImages;


